import { InjectionToken } from '@angular/core';

export {};

declare global {
  interface Window {
    zbLoginInterop?: {
      notifyLoginComplete(userId: string, classroomId: string, topicKey: string, apiToken: string): void;
    }
  }
}

/**
 * We should be using this injection token to get an instance of the window through dependency injection, instead
 * of just using the globally available `window` variable. This is because using dependency injection gives us
 * the ability to mock the window during tests / even provide alternative window instances in the future if required.
 */
export const WINDOW = new InjectionToken<Window>('Global Window Object', {
  factory: () => window,
});
